import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({});

const reduce = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
};

store.registerDynamicModule("consultaSolicitacao", reduce);
